import { defineType } from 'sanity'

export default defineType({
  title: 'Years',
  name: 'years',
  type: 'string',
  description:
    'Comma separated years and ranges. eg. 1977,1978,1980-1985,2005+,2045',
})